module.exports = __webpack_public_path__ + "img/VP-ProfiNew_Overview-Rear_2.a35c3b04.jpg";